import React from 'react';
import ReactDOM from 'react-dom';
import '../stylesheets/popup.css';

const Popup = ({ children, title, onClose }) => {
  return ReactDOM.createPortal(
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        {title && <h2 className="popup-title">{title}</h2>}
        {children}
        <button className="close-button" onClick={onClose}>×</button>
      </div>
    </div>,
    document.getElementById('popup-root')
  );
};

export default Popup;
